import ThreeDimensionalCardContainer from '../../gameplay/containers/threeDimensionalCardContainer';
import { definePrefab } from '../prefab';
import { PLACEHOLDER_CARD_FILE, placeholderCardTexture } from '../placeholderCard';

const CARD_PERSPECTIVE = 900;

export const cardPrefab = definePrefab({
    id: 'card',
    name: '3D card',
    load: async () => {
        await ThreeDimensionalCardContainer.loadAssets();
        placeholderCardTexture();
    },
    create: () => {
        const card = new ThreeDimensionalCardContainer({
            id: 'preview-card',
            type: 'Character',
            imgUrl: PLACEHOLDER_CARD_FILE,
        });
        card.frontFacePerspectiveMesh.texture = placeholderCardTexture();
        return card;
    },
    parts: {
        card: {
            name: 'Card',
            perspective: CARD_PERSPECTIVE,
            pick: (root) => root,
        },
    },
    clips: [],
});
